<template>
  <div :class="{ box:isBoxed, 'top-margin-is-1':!isBoxed }" :name="instanceName">
    <section-header :title="title" v-if="title !== ''" :allowCollapse="false"></section-header>
    <div class="columns">
      <div class="column is-12">
        <p class="label" style="margin-left:10px;">
          {{ label }}
          <b-icon pack="fas" icon="star" class="fa-ss" v-if="required"></b-icon>
        </p>
      </div>
    </div>
    <div class="columns">
      <div class="column is-12">
        <div v-viewer="{title: false}" class="item-container">
          <div class="is-inline-flex iPhoto" v-if="!disabled">
            <div>
              <b-upload v-model="uploadValue"
                type="is-info"
                :multiple="multiple"
                :disabled="shouldBeDisabled"
                accept="image/*"
                @input="loadLocalImages"
                drag-drop>
                <div class="upload-instructions">
                  <div class="has-text-centered">
                    <p>Drop your files here or click to upload</p>
                    <i class="fal fa-upload" style="margin-top:10px;"></i>
                  </div>
                </div>
              </b-upload>
            </div>
          </div>
          <div class="is-inline-flex iPhoto" v-for="(file, index) in validFiles" :key="index">
            <div class="box" :title="file.name">
              <figure class="image is-64xauto">
                <img :src="file.imageData" style="max-height:64px">
              </figure>
              <div class="tags has-addons extra-top-margin">
                <span class="tag is-link" v-if="file.isUploadError">{{ uploadErrorDescription }}</span>
                <span class="tag is-link" v-if="!file.isUploadError && !file.isUploading">{{ shortened(file.name) }}</span>
                <span class="tag is-link" v-if="!file.isUploadError && file.isUploading">upload progress: {{ file.uploadPercentage }}%</span>
                <span class="tag is-delete" @click="deleteImage(index)" v-if="!disabled"></span>
              </div>
            </div>
          </div>
          <br/>
        </div>
      </div>
    </div>
    <input :name="instanceName" v-validate="{'required': required}" :data-vv-as="label" :class="{'input': true, 'is-danger': errors.has('instanceName')}" type="hidden" v-model="isFileUploaded">
    <span v-if="isFileUploaded !== 'yes'" v-show="errors.has(validationName)" class="help is-danger"><i v-show="errors.has(validationName)" class="fas fa-exclamation-triangle"></i> {{ errors.first(instanceName) }}</span>
  </div>
</template>

<script>

import SectionHeader from '@/components/generic/SectionHeader'
import axios from 'axios'

export default {
  inject: {
    $validator: '$validator'
  },
  components: {
    'section-header': SectionHeader
  },
  name: 'ImageSelector',
  props: {
    value: {
      type: Array,
      default: null
    },
    title: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: 'Images'
    },
    validateAs: {
      type: String,
      default: 'Item'
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isBoxed: {
      type: Boolean,
      default: true
    },
    multiple: {
      type: Boolean,
      default: true
    },
    scope: {
      type: String,
      default: null
    },
    destinationUrl: {
      type: String,
      default: ''
    },
    token: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      uploadValue: null,
      selectedImages: this.value,
      instanceName: this.$uuid.v4()
    }
  },
  computed: {
    validationName: function () {
      return this.scope ? this.scope + '.' + this.instanceName : this.instanceName
    },
    filesValid: function () {
      return this.selectedImages.length > 0
    },
    validFiles: function () {
      return this.selectedImages.filter((x) => x.loaded === true && (!x.status || x.status !== 'Deleted'))
    },
    shouldBeDisabled: function () {
      if (this.disabled === true) {
        return true
      }
      if (this.multiple === true) {
        return false
      } else {
        if (this.validFiles.length > 0) {
          return true
        }
      }
      return false
    },
    isFileUploaded: function () {
      return this.selectedImages.length > 0 ? 'yes' : ''
    }
  },
  methods: {
    shortened (name) {
      return this.$lodash.truncate(name, { length: 15, separator: ' ' })
    },
    deleteImage (index) {
      var list = this.selectedImages
      var file = list[index]
      if (file.status) {
        this.$set(file, 'status', 'Deleted')
      } else {
        list.splice(index, 1)
      }
      this.$emit('input', this.selectedImages)
    },
    loadLocalImages (imageList) {
      if (!Array.isArray(imageList)) {
        imageList = [imageList]
      }
      imageList.forEach(function (file, index) {
        var found = this.selectedImages.find(x => x.name === file.name && x.size === file.size)
        if (!file.imageData && !found) {
          var uniqueFileName = this.$uuid.v4() + this.getFileExtension(file.name)
          uniqueFileName = uniqueFileName.replace(/-/g, '')
          var reader = new FileReader()
          reader.onload = (e) => {
            var clone = { size: file.size, name: file.name, type: file.type }
            clone.imageData = e.target.result
            clone.loaded = true
            clone.isUploaded = false
            clone.isUploading = false
            clone.uploadPercentage = 0
            clone.isUploadError = false
            clone.uploadErrorDescription = ''
            clone.uniqueId = uniqueFileName
            clone.status = 'Active'
            this.selectedImages.push(clone)
            this.uploadFile(file, uniqueFileName, clone)
          }
          reader.readAsDataURL(file)
        }
      }, this)
    },
    getFileExtension: function (fileName) {
      return '.' + fileName.split('.').pop()
    },
    resetUploadStatus: function (clone) {
      clone.uploadPercentage = 0
      clone.isUploading = true
      clone.isUploadError = false
      clone.uploadErrorDescription = ''
    },
    uploadFile: function (file, uniqueName, clone) {
      this.resetUploadStatus(clone)
      var formData = new FormData()
      formData.append(uniqueName, file)
      axios.post(this.destinationUrl, formData, {
        params: {
          token: this.token
        },
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: progressEvent => {
          clone.uploadPercentage = ((progressEvent.loaded / progressEvent.total) * 100).toFixed(2)
        }
      }).then((response) => {
        clone.isUploading = false
        const item = response.data.results[0]
        if (!item.isValid) {
          clone.isUploadError = true
          clone.uploadErrorDescription = item.error
        } else {
          clone.isUploaded = true
          clone.uploadErrorDescription = ''
          // this.$emit('input', this.selectedImages)
        }
      }).catch((error) => {
        clone.isUploadError = true
        clone.uploadErrorDescription = error.message
      })
    }
  },
  watch: {
    selectedImages: function (newValue, oldValue) {
      this.$emit('input', newValue)
    },
    value: function (newValue, oldValue) {
      if (newValue === null) {
        this.selectedImages = []
      } else {
        this.selectedImages = newValue
      }
    }
  },
  mounted: function () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .iPhoto {
    margin: 5px;
  }

  .item-container {
    display: flex;
    flex-wrap: wrap;
  }

  .columns {
    display:flex;
  }

  .column {
    padding:0 !important
  }

  .top-margin-is-1 {
    margin-top:12px
  }

  .is-128xauto {
    display: -webkit-box;
    height:128px;
    width:auto;
    align-items: center;
    justify-content: center
  }

  .is-64xauto {
    display: -webkit-box;
    height:64px;
    width:auto;
    align-items: center;
    justify-content: center
  }

  .image img {
    display: block;
    height:auto;
    width:auto;
  }

  .upload-instructions {
    width:118px;
    height:97px;
    margin:1em;
  }

  .extra-top-margin {
    margin-top:10px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>
